/* eslint-disable */
import messageTypes from '@ringcentral-integration/commons/enums/messageTypes';
export default {
  title: 'Mensajes',
  search: 'Buscar…',
  composeText: 'Redactar mensaje',
  noMessages: 'Sin mensajes',
  noSearchResults: 'No se han encontrado registros que coincidan',
  [messageTypes.all]: 'Todos',
  [messageTypes.voiceMail]: 'Voz',
  [messageTypes.text]: 'Mensaje',
  [messageTypes.fax]: 'Fax',
} as const;

// @key: @#@"title"@#@ @source: @#@"Messages"@#@
// @key: @#@"search"@#@ @source: @#@"Search..."@#@
// @key: @#@"composeText"@#@ @source: @#@"Compose Text"@#@
// @key: @#@"noMessages"@#@ @source: @#@"No Messages"@#@
// @key: @#@"noSearchResults"@#@ @source: @#@"No matching records found"@#@
// @key: @#@"[messageTypes.all]"@#@ @source: @#@"All"@#@
// @key: @#@"[messageTypes.voiceMail]"@#@ @source: @#@"Voice"@#@
// @key: @#@"[messageTypes.text]"@#@ @source: @#@"Text"@#@
// @key: @#@"[messageTypes.fax]"@#@ @source: @#@"Fax"@#@
